module.exports = __webpack_public_path__ + "img/food.5b38ca8f.jpg";